import { Flex, Link } from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import MotivoSituacaoService from "../../../main/services/MotivoSituacaoService";
import Tabela from '../../components/Tabela';
import { Link as ReactLink } from 'react-router-dom';
import { isEmptyArray } from "formik";
import Loading from "../../components/Loading";
import { format } from 'date-fns';
import { motivoFunc } from '../../../helpers/Funcionalidades';
import { useAuthProvider } from "../../../Context/AuthProvider"

const ListaMotivoSituacao = () => {
    const { roleKeycloack } = useAuthProvider();
    document.title = 'MCA - Motivo de Situação'


    function isValidDate(ano, mes, dia, horas, minutos, segundos) {
        return (
            !isNaN(ano) &&
            !isNaN(mes) &&
            !isNaN(dia) &&
            !isNaN(horas) &&
            !isNaN(minutos) &&
            !isNaN(segundos)
        );
    }

    const _IsMounted = useRef(false);
    const [columns] = useState([
        {
            Header: 'Descrição',
            accessor: 'descricao',
            width: 70,
            Cell: (props => {

                const id = props.row.original.id;
                var descricao = props.value;

                if (descricao.length > 100) {
                    descricao = descricao.substring(0, 100) + "..."
                }
                return roleKeycloack && roleKeycloack.includes(motivoFunc.motivoVisualizar) ? <Link title={props.value} as={ReactLink} to={"/motivo-situacao/" + id}>{descricao}</Link> : <span>{descricao}</span>
            })
        },
        {
            Header: 'Tipo',
            accessor: 'tipoSituacao',
            Cell: (props) => {

                let retorno = "";
                switch (props.value.id) {
                    case 1:
                        retorno = "Acolhido"
                        break
                    case 4:
                        retorno = "Transferido"
                        break
                    case 3:
                        retorno = "Pendente"
                        break
                    case 2:
                        retorno = "Desligado"
                        break
                    default:
                        retorno = ""
                }
                return <span>{retorno}</span>;

            }
        },
        {
            Header: 'Data Início',
            accessor: 'dataInicio',
            Cell: (props) => {
                if (props.value && Array.isArray(props.value) && props.value.length > 0) {
                    if (props.value !== null) {
                        const [ano, mes, dia, horas, minutos, segundos] = props?.value;
                        if (isValidDate(ano, mes, dia, horas, minutos, segundos)) {
                            const dateObject = new Date(ano, mes - 1, dia, horas, minutos, segundos);
                            const formattedDate = format(dateObject, 'dd/MM/yyyy');
                            return <span>{formattedDate}</span>;
                        } else {
                            return <span>{""}</span>;
                        }
                    } else {
                        return <span>{""}</span>
                    }

                } else {
                    return <span>{""}</span>
                }
            }
        },
        {
            Header: 'Data de término',
            accessor: 'dataFim',
            // disableSortBy: true,
            Cell: (props) => {
                if (props.value && Array.isArray(props.value) && props.value.length > 0) {
                    if (props.value !== null) {
                        const [ano, mes, dia, horas, minutos, segundos] = props?.value;
                        if (isValidDate(ano, mes, dia, horas, minutos, segundos)) {
                            const dateObject = new Date(ano, mes - 1, dia, horas, minutos, segundos);
                            const formattedDate = format(dateObject, 'dd/MM/yyyy');
                            return <span>{formattedDate}</span>;
                        } else {
                            return <span>{""}</span>;
                        }
                    } else {
                        return <span>{""}</span>
                    }

                } else {
                    return <span>{""}</span>
                }
            }
        },
    ])
    const [data, setData] = useState([{}]);
    const [fixedData, setFixedData] = useState([]);
    const [filter] = useState('');
    const [loading, setLoading] = useState(true);
    const [nullData, setNullData] = useState(true)

    useEffect(() => {
        setLoading(true)
        _IsMounted.current = true;
        fetchData();

        return () => {
            _IsMounted.current = false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function getMotivoSituacao() {
        return MotivoSituacaoService.listarMotivoSituacao();
    }

    function fetchData(state) {
        setLoading(true)
        getMotivoSituacao()
            .then(res => {
                if (!isEmptyArray(res.data)) {
                    setNullData(false)
                }
                setData(res.data)
                setFixedData(res.data)
                setLoading(false)

            }).catch((error) => {
                console.warn(error)
            })
    }


    return (

        <Flex
            pt={"20px"}
            px={["5px", "30px"]}
            h="100%"
            flexDir="column"
            w="100%"
            maxW="2000px"
            overflow="auto"
            pb={["10px", "20px"]}
        >

            <Flex
                w="100%"
            >

            </Flex>
            {loading ? (
                <Loading />
            ) : (
                <Flex>
                    <Tabela
                        data={data}
                        loading={loading}
                        columns={columns}
                        setLoading={setLoading}
                        filter={filter}
                        setData={setData}
                        dataNull={nullData}
                        fixedData={fixedData}
                        roleKeycloack={roleKeycloack}
                        placeholderFilter="Pesquise pelo Motivo de Situação"
                        entidade="motivo-situacao"
                    />
                </Flex>
            )}
        </Flex>
    )
}

export default ListaMotivoSituacao;